module.exports = "<div class=\"resource-item-content resource-reel-item\">\r\n   <h3>Get certified</h3>\r\n   <p>Improve your legal research skills with the <a class=\"proficiency-link\" href=\"https://www.classmarker.com/online-test/start/?quiz=a3456387d50b39e7\" target=\"_blank\">JustisOne Proficiency Test</a></p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/overview-resource-proficiency.html
// module id = 382
// module chunks = 1